import React, { Component } from 'react';
import logo from '../../assets/img/logo.svg';
import css from './header.scss';

class Header extends Component {
	render() {
		return (
			<header className={css.header}>
				<img src={logo} className={css.logo} alt="Solar Management" />
			</header>
		);
	}
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/header.js